import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HubIcon from '@mui/icons-material/Hub';
import SecurityIcon from '@mui/icons-material/Security';
import DevicesIcon from '@mui/icons-material/Devices';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FactoryIcon from '@mui/icons-material/Factory';
import PublicIcon from '@mui/icons-material/Public';
import MemoryIcon from '@mui/icons-material/Memory';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BusinessIcon from '@mui/icons-material/Business';
import PsychologyIcon from '@mui/icons-material/Psychology';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import InsightsIcon from '@mui/icons-material/Insights';
import Text from '../Text';
import SectionHeader from '../SectionHeader';
import ScrollReveal from '../animated/ScrollReveal';
import { colors, gradients } from '../../theme/designTokens';
import { capabilities } from '../../data/capabilities';

const icons = [
  <HubIcon key="1" />,
  <SecurityIcon key="2" />,
  <DevicesIcon key="3" />,
  <LocalShippingIcon key="4" />,
  <FactoryIcon key="5" />,
  <PublicIcon key="6" />,
  <MemoryIcon key="7" />,
  <AssessmentIcon key="8" />,
  <BusinessIcon key="9" />,
  <PsychologyIcon key="10" />,
  <HealthAndSafetyIcon key="11" />,
  <InsightsIcon key="12" />,
];

const CapabilitiesGrid = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 8, md: 12 },
        background: gradients.sectionSoft,
      }}
    >
      <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
        <ScrollReveal>
          <SectionHeader
            eyebrow="Strategic Capabilities"
            title="Capabilities that build resilience."
            highlightWords={['Capabilities']}
            subtitle="Twelve strategic capabilities—designed as an integrated system, not a menu of products."
          />
        </ScrollReveal>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {capabilities.map((cap, i) => (
            <Box
              key={cap.slug}
              component="button"
              type="button"
              onClick={() => navigate(`/capabilities/${cap.slug}`)}
              sx={{
                textAlign: 'left',
                cursor: 'pointer',
                border: `1px solid ${colors.borderLight}`,
                background: colors.white,
                p: 3,
                transition: 'all 0.3s ease',
                '&:hover': {
                  borderColor: colors.navy,
                  transform: 'translateY(-3px)',
                  boxShadow: '0 12px 40px rgba(15,23,42,0.08)',
                },
              }}
            >
              <Box sx={{ color: colors.navy, mb: 2, display: 'flex', '& svg': { fontSize: 28 } }}>
                {icons[i]}
              </Box>
              <Text variant="h4" color="primary" sx={{ mb: 1 }}>
                {cap.title}
              </Text>
              <Text variant="bodySm" color="secondary">
                {cap.summary}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CapabilitiesGrid;
